/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/17/20
 * Time: 8:46 AM
 */

/* eslint-disable*/
import React from "react";
// core components
import CardsFooter from "../../../../components/Modals/Footers/CardsFooter.js";
import Header from '../../../../components/Header/Header';
import './TeacherVersion01.scss';
import CourseSlides from "../../../../components/CourseSlides/CourseSlides";
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router";
import * as instituteService from "../../../../services/institute";
import * as commonFunc from "../../../../utils/commonFunc";
import * as actionSpinnerCreator from "../../../../store/domain/spinner/action";
import * as actionClassCreator from "../../../../store/domain/classes/action";
import * as actionLectureCreator from "../../../../store/domain/lecturer/action";
import NotFound from "../../../../components/NotFound/NotFound";
import * as constants from "../../../../const/constants";
import {lang, language} from "../../../../const/language";
import LessonItem from "../../../../components/LessonItem/LessonItem";
import i from "react-icofont";
import AuthButtonGroup from "../../../../components/AuthButtonGroup/AuthButtonGroup";
import webConfig from '../../../../config/WebConfig';
import VideoPlayerView from "../../../../components/YoutubePlayerViwe/VideoPlayerView";
import HowItsWork from "../../../../components/HowItsWork/HowItsWork";
import TimetableView from "../../../../components/Timetable/Timetable";
import LessonViewTile from '../../LessonsSeparate/LessonViewTile/lessonViewTile';

class Teacher extends React.Component {

    state = {
        lessons: [],
        classes: [],
        privileges: '0'
    }

    fetchClassesFromHome = async () => {
        let state = this.props.match.params.teacher_name;
        if (state) {
            this.props.spinnerHandler({isSpin: true, type: 15});
            await instituteService.getTeacherDetails(state)
                .then(response => {
                    this.props.spinnerHandler(false);
                    if (response.success) {
                        let body = response.body;
                        let data = [{
                            classes: body.classes,
                            teacherId: body.id,
                            teacherName: body.name
                        }];
                        this.props.fetchLecture({
                            name: body.name,
                            about: body.description,
                            image: body.imageUrl,
                            defaultImage: '',
                            qualification: body.qualification,
                            coverImage: body.coverImage,
                            privileges: body.privileges
                        });
                        this.props.fetchLectures(data);
                        this.setState({
                            lessons: body.lessons,
                            classes: body.classes,
                            privileges: body.privileges.split(':')[1]
                        })
                    } else {
                        commonFunc.notifyMessage(response.message, response.status)
                    }
                })
        } else {
            this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`)
        }
    };

    setModalHandler = () => {
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`)
    };

    componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        console.log(this.props);
        if (webConfig.LMSStatus==='LMS') {
            this.fetchClassesFromHome();
        }else{
            let data = this.props.location.state;
            console.log(data);
            this.props.fetchLecture({
                name: data.name,
                about: data.description,
                image: data.imageUrl,
                defaultImage: '',
                qualification: data.qualification,
                coverImage: data.coverImage,
                privileges: data.privileges
            });
            console.log(data.classes);
            this.setState({
             //   lessons: data.lessons,
                classes: data.classes,
               //  privileges: data.privileges.split(':')[1]
            })
        }
    }

    render() {
        let {lecturer, listOfLectures, userType} = this.props;
        if (this.state.classes && this.state.classes !== 0) {
            this.state.classes.sort(function (a, b) {
                return a.id - b.id
            });
        }
        // console.log(this.state.classes);
        const cover = 'https://assets.edulab.lk/common-assets/banner-bg.jpg';

        return (
            <div>
                <Header active={0}/>
                <main ref="main" className={"main"}>

                    <section className="profile-layer">
                        <img
                            src={lecturer.coverImage ? lecturer.coverImage : cover}
                            alt={"."}
                            className={"slideshow-pro-image"}/>


                        <img src={lecturer.image} className={"profile-image"} alt="."/>

                        <i className="icofont-arrow-left back" onClick={() => window.history.back()}/>
                    </section>
                    <section className="section name pb-0">

                        <div className=" mb-3 pl-lg-8 pr-lg-8 pb-1">
                            <h3 className={"lecture-name"}>{lecturer.name}</h3>
                            <p className={"none-margin_"}>{lecturer.qualification}</p>

                        </div>
                    </section>

                    <section className="section pt-0">
                        <div className="about2">
                            <p className={"about-para"}>{lecturer.about}</p>
                        </div>
                    </section>

                    {
                        this.state.classes.length === 0 && !this.props.isSpinner &&
                        <NotFound message={`Available classes`}/>
                    }

                    {
                        this.state.classes.length !== 0 &&
                        <section className="container class-section">
                            <div className="about2">
                                <h3 className={"class-topic"}>{lecturer.name}'s Classes</h3></div>
                            {/* <h3 className={"class-ctrl"}>Classes</h3> */}
                            <CourseSlides classesByLecture={this.state.classes} privileges={this.state.privileges}/>
                        </section>
                    }

                    {
                        this.state.lessons.length !== 0 &&
                        <section className="container class-section">
                            <div className="about2">
                                <h3 className={"class-topic"}>Physical Classes</h3></div>
                            {/* <h3 className={"class-ctrl"}>Classes</h3> */}
                            <LessonViewTile lessons={this.state.lessons} />
                        </section>
                    }
                    <VideoPlayerView youtubeLikes={webConfig.youtubeRefVideoLink}/>
                    {/*<TimetableView/>*/}

                </main>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    lecturer: state.lecturer.lecturer,
    listOfLectures: state.classes.listOfLectures,
    pagination: state.classes.pagination,
    isSpinner: state.spinner.isSpinner,
    userType: state.auth.userType,
});
const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    fetchLectures: data => dispatch(actionClassCreator.fetchLectures(data)),
    fetchLecture: data => dispatch(actionLectureCreator.fetchLecture(data)),
    selectPagination: data => dispatch(actionClassCreator.selectPagination(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Teacher));
